import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    initialLoading: true,
    loading: false,
    serverTimeDataObj: {},
    error: false,
    errorMessage: ''
};

const serverDateTimeSlice = createSlice({
    name: 'serverDateTime',
    initialState,
    reducers: {
        resetServerDateTime: () => initialState,
        initServerDateTimeRequest: state => {
            state.loading = true;
            state.error = false;
            state.errorMessage = '';
        },
        getServerDateTimeSuccess: (state, action) => {
            state.initialLoading = false;
            state.loading = false;

            let serverDateTime = { ...action.payload, date: action.payload.date?.replace("Z", "") }
            state.serverTimeDataObj = serverDateTime;
        },
        getServerDateTimeFailure: (state, action) => {
            state.initialLoading = false;
            state.loading = false;
            state.error = action.payload.isError;
            state.errorMessage = action.payload.errorMessage;
        },
    },
});

export const {
    resetServerDateTime,
    initServerDateTimeRequest,
    getServerDateTimeSuccess,
    getServerDateTimeFailure,
} = serverDateTimeSlice.actions;

export default serverDateTimeSlice.reducer;
